package com.example.mystybag.common.views

import androidx.compose.runtime.Composable
import com.example.mystybag.core.logic.base.BottomSheetChild
import com.example.mystybag.common.logic.ChooseTakePhotoOrPickFileBottomSheetChild
import com.example.mystybag.common.logic.FilterBottomSheetChild
import com.example.mystybag.common.logic.RateAppBottomSheetChild

@Composable
fun CommonBottomSheetFactory(child: BottomSheetChild) {
    when (child) {
        is ChooseTakePhotoOrPickFileBottomSheetChild    -> ChooseTakePhotoOrPickFileBottomSheetView(child.title, child.infoText, child.onInfoButtonClicked, child.additionalRows)
        is RateAppBottomSheetChild                      -> RateAppBottomSheetView(child.onLaterClicked, child.onRateUsClicked)
        is FilterBottomSheetChild                       -> FilterBottomSheetView(child.viewModel)
    }
}